import _ from "lodash"

// const serverImportFilePath = process.env.SERVER_IMPORT_URL
const serverImportFilePath = "http://VIP.getech.com.tw:6050/dataImport/"

export const dataImportType = [
  {
    typeName: "公司",
    description: "匯入公司資料，需注意必填欄位",
    sampleUrl: `${serverImportFilePath}company.csv`,
    uploadType: "COMPANY",
    iconClass: "mdi mdi-briefcase"
  },
  {
    typeName: "使用者",
    description: "匯入使用者資料，需注意必填欄位(請先匯入公司資料)",
    sampleUrl: `${serverImportFilePath}user.csv`,
    uploadType: "USER",
    iconClass: "mdi mdi-account"
  },
  {
    typeName: "設備",
    description: "匯入設備資料，需注意必填欄位",
    sampleUrl: `${serverImportFilePath}device.csv`,
    uploadType: "DEVICE",
    iconClass: "ti-harddrive"
  },
  {
    typeName: "公司設備",
    description: "匯入公司設備資料，需注意必填欄位(請先匯入公司資料)",
    sampleUrl: `${serverImportFilePath}companyDevice.csv`,
    uploadType: "COMPANYDEVICE",
    iconClass: "mdi mdi-server-network"
  },
  {
    typeName: "主類別與次類別",
    description: "匯入主類別與次類別資料，需注意必填欄位",
    sampleUrl: `${serverImportFilePath}categorySubcategory.csv`,
    uploadType: "CATEGORYSUBCATEGORY",
    iconClass: "mdi mdi-file-tree"
  },
  {
    typeName: "產品",
    description: "匯入產品資料，需注意必填欄位(請先匯入主類別與次類別資料)",
    sampleUrl: `${serverImportFilePath}product.csv`,
    uploadType: "PRODUCT",
    iconClass: "mdi mdi-shape-plus"
  },
  {
    typeName: "價目表",
    description: "匯入價目表資料，需注意必填欄位(請先匯入公司，產品資料)",
    sampleUrl: `${serverImportFilePath}pricebook.csv`,
    uploadType: "PRICEBOOK",
    iconClass: "fas fa-tag"
  },
  {
    typeName: "訂單",
    description: "匯入訂單資料，需注意必填欄位(請先匯入公司，使用者資料)",
    sampleUrl: `${serverImportFilePath}order.csv`,
    uploadType: "ORDER",
    iconClass: "mdi mdi-cart"
  },
  {
    typeName: "訂單明細",
    description:
      "匯入訂單明細資料，需注意必填欄位(請先匯入公司，使用者，訂單資料)",
    sampleUrl: `${serverImportFilePath}orderDetail.csv`,
    uploadType: "ORDERDETAIL",
    iconClass: "mdi mdi-file"
  }
]

export const getImportTypeDefinition = (type) => {
  return _.find(dataImportType, { uploadType: type })
}
